import { isDark } from 'components/utils/isDark';

const type = isDark();
// const type = 'dark';
export default {
  secondary: {
    main: '#e89048',
  },
  primary: {
    main: '#4475DB',
  },
  error: {
    main: '#f12e2e',
  },
  // background: {
  //   // default: type === 'light' ? '#FAFAFA': '#333030',
  //   // paper  : type === 'light' ? '#F4F3F4': '#8F8F8F',
  // },
  // success: {
  //   main: '#27AE60',
  // },
  // warning: {
  //   main: '#F39C12',
  // },
  // info: {
  //   main: '#2980B9',
  // },
  // border : '#DFE3E8',
  divider: '#DFE3E8',
  type,
};
